import { useCallback, useState } from 'react';

interface AdAccountPickState {
  // The account the marketer actively picked, or null while they have not.
  // Never a guess: an absent pick means the server's own resolution stands.
  pickedAdAccountId: string | null;
  pickAdAccount: (adAccountId: string) => void;
}

/**
 * The marketer's explicit ad-account choice for one mention.
 *
 * It sits above the setup query because the readiness that query returns is
 * resolved against a single account: the pick has to reach the server for its
 * blockers to describe the account being billed. The mention id is stored
 * alongside the pick and compared on read, so switching mentions drops the
 * choice without an effect that would briefly leak it to the new one.
 */
export function useAdAccountPick(mentionId: string): AdAccountPickState {
  const [pick, setPick] = useState<{ mentionId: string; adAccountId: string } | null>(null);

  const pickAdAccount = useCallback(
    (adAccountId: string) => setPick({ mentionId, adAccountId }),
    [mentionId]
  );

  return {
    pickedAdAccountId: pick?.mentionId === mentionId ? pick.adAccountId : null,
    pickAdAccount,
  };
}
